import {createContext, getContextOrThrow} from 'src/core';
import type {Readable} from 'svelte/store';

export const THEME_LOCAL_STORAGE_KEY = 'portaro-theme';
const themeContextKey = Symbol('portaro-theme-ctx');

export type PortaroTheme = 'light' | 'dark';

export interface ThemeContext {
    currentTheme: Readable<PortaroTheme>;
    changeTheme: (value: PortaroTheme) => void;
}

export function createThemeContext(context: ThemeContext) {
    createContext<ThemeContext>(themeContextKey, context);
}

export function getThemeContext() {
    return getContextOrThrow<ThemeContext>(themeContextKey);
}